import Image from "next/image";
import moment from "moment";
import Link from "next/link";
import { useRouter } from "next/router";

const ArticleCard = ({ article }) => {
    const router = useRouter()

    const currentLang = router.asPath.includes('/blog/en') ? 'en' : 'tr';
    const isFullSlug = article?.category_slug.startsWith('/blog/tr') || article?.category_slug.startsWith('/blog/en');

    return (
        <div className="h-[500px] lg:h-[200px] mt-7 lg:mt-0 bg-white shadow-custom lg:shadow-none w-full p-7 space-y-7  lg:space-y-0 rounded-lg flex flex-col">
            <div className="grid flex-1 lg:grid-cols-5 lg:space-x-3">
                <Link
                    href={isFullSlug ? `${article?.category_slug}/${article?.connection_id}/${article?.slug}` : `/blog/${currentLang}/${article?.category_slug}/${article?.connection_id}/${article?.slug}`}
                >
                    <div className="relative h-[250px] w-full col-span-1 lg:col-span-2 lg:h-[160px] cursor-pointer">
                        <Image
                            src={article?.image ? process.env.NEXT_PUBLIC_FRONTPAGE_URL + article?.image : "/dummyhighlight.svg"}
                            layout="fill"
                            alt={article?.title}
                            title={article?.title}
                            className="rounded-md !h-[160px]"
                        />
                    </div>
                </Link>

                <div className="flex flex-col justify-between col-span-1 lg:col-span-3">
                    <Link
                        href={isFullSlug ? `${article?.category_slug}/${article?.connection_id}/${article?.slug}` : `/blog/${currentLang}/${article?.category_slug}/${article?.connection_id}/${article?.slug}`}
                    >
                        <div className="-mt-16 cursor-pointer lg:mt-0">
                            <h2 className="text-2xl font-semibold" title={article?.title}>
                                {article?.title.length > 65 ? article?.title.substring(0, 65) + '...' : article?.title}
                            </h2>
                            <p className="text-sm text-textGray" title={article?.description}>
                                {article?.description.length > 110 ? article?.description.substring(0, 110) + '...' : article?.description}
                            </p>
                        </div>
                    </Link>
                    <div className="flex items-center justify-between mt-auto">
                        <Link
                            href={
                                isFullSlug
                                    ? article?.category_slug
                                    : `/blog/${currentLang}/${article?.category_slug}`
                            }
                        >
                            <div className="flex items-center justify-center p-2 space-x-2 text-sm rounded-full cursor-pointer text-textGray bg-buttonBg">
                                <div className="w-3 h-3 rounded-full bg-makdosYellow"></div>
                                <p>
                                    {article?.category_title.length > 15
                                        ? article?.category_title.substring(0, 15) + "..."
                                        : article?.category_title}
                                </p>
                            </div>
                        </Link>

                        <Link
                            href={isFullSlug ? `${article?.category_slug}/${article?.connection_id}/${article?.slug}` : `/blog/${currentLang}/${article?.category_slug}/${article?.connection_id}/${article?.slug}`}
                        >
                            <div className="flex items-center justify-center space-x-3 cursor-pointer">
                                <div className="flex space-x-0.5 text-sm text-textGray">
                                    <i className="ri-calendar-2-line"></i>
                                    <p>{moment(article?.create_time).format("DD.MM.YYYY")}</p>
                                </div>
                                <div className="flex space-x-0.5 text-sm text-textGray">
                                    <i className="ri-user-line"></i>
                                    <p>{article?.created_by ? article?.created_by : "Makdos"}</p>
                                </div>
                            </div>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ArticleCard